import { useAppDispatch } from "redux/hooks";
import { useSnackbar } from "notistack";

export default function useAppDispatchWithSnackbar(): (
  action: any,
  options: {
    successMessage?: string;
    errorMessage?: string;
  }
) => Promise<any> {
  const dispatch = useAppDispatch();
  const { enqueueSnackbar } = useSnackbar();

  return function (action, options) {
    return dispatch(action)
      .unwrap()
      .then((r: any) => {
        if (options.successMessage) enqueueSnackbar(options.successMessage, { variant: "success" });
        return r;
      })
      .catch((e: any) => {
        if (options.errorMessage && e.message?.name !== "ConditionError" && e.name !== "ConditionError")
          enqueueSnackbar(options.errorMessage, { variant: "error" });
        else if (options.errorMessage === undefined && typeof e.message === "string") {
          enqueueSnackbar(e.message, { variant: "error" });
        }
        // Do not throw for condition error passed by canceled thunks since it's not an error we want in Sentry
        if (e.name !== "ConditionError") {
          throw e;
        }
      });
  };
}
